export const formatGenericDate = (
  date: Date,
  locale: string,
  format: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  },
): string => {
  if (!date || Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, format).format(date)
}

const RELATIVE_TIME_DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
]

/**
 * Formats a date as a locale-aware relative time (e.g. "3 hours ago",
 * "yesterday"). Falls back to years for very old dates.
 * Returns empty string for invalid dates.
 */
export const formatRelativeTime = (date: Date, locale: string): string => {
  if (!date || Number.isNaN(date.getTime())) return ''

  const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  let duration = (date.getTime() - Date.now()) / 1000

  for (const division of RELATIVE_TIME_DIVISIONS) {
    if (Math.abs(duration) < division.amount) {
      return formatter.format(Math.round(duration), division.unit)
    }
    duration /= division.amount
  }

  return formatter.format(Math.round(duration), 'year')
}
